<template>
  <div>
    <div class="bg-white px-2 pt-3 pb-0 d-flex align-items-center page-header border-0" style="padding-bottom: 0">
      <div class="col">
        <div>
          <h4>
            <b-icon class="me-2" icon="graph-up"></b-icon>
            Berichte
          </h4>
        </div>
        <!--
        <div class="text-uppercase text-secondary"><small>Kostengruppen und Vergabeeinheiten</small></div>
        -->
      </div>
      <div class="col-auto">
        <div class="form-inline">
          <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->

          <!-- HELP ICON  -->
          <b-button size="sm" variant="light" class="ml-2" href="https://www.bauvisor.de/berichte/" target="_blank">
            <b-icon icon="question-circle" variant="dark" class=""></b-icon>
          </b-button>
        </div>
      </div>
    </div>

    <b-tabs
      v-model="activeTab"
      content-class="px-0 py-0 bg-white "
      class="mt-3 form-tabs border-bottom"
      v-show="report.KkeBudgetSummary"
    >
      <b-tab
        ref="tabA"
        title="Gesamtübersicht"
        class="p-4"
        :style="{ height: 'calc(100vh - 100px)', overflowY: 'auto', overflowX: 'auto', position: 'relative' }"
        v-show="report.KkeBudgetSummary"
      >
        <table id="reportTable">
          <tr>
            <td colspan="4" class="bg-primary"></td>
            <td colspan="2" class="text-white text-right bg-primary" style="min-width: 128px">FREIGABE - BUDGET</td>
            <td colspan="7"></td>
            <td colspan="4" class="bg-secondary"></td>
            <td class="text-white text-right bg-secondary" style="min-width: 128px">PROGNOSE</td>
          </tr>
          <tr>
            <td colspan="5"></td>
            <td class="text-right bg-primary-light text-nowrap"></td>
            <td colspan="7"></td>
            <td colspan="4" style="padding-left: 20px"></td>
            <td class="text-right bg-secondary-light text-nowrap"></td>
          </tr>
          <tr>
            <td colspan="5"></td>
            <td class="bg-primary-light"></td>
            <td colspan="7" class="text-center">
              <div style="position: relative">
                <div style="position: absolute; top: -30px; left: 0; right: 0; margin-left: auto; margin-right: auto">
                  <h6 class="mb-0">
                    PROGNOSEABWEICHUNG inkl. Projektrisiken
                    <b-icon
                      style="vertical-align: -0.12em; margin-left: 3px"
                      icon="question-circle"
                      title=" = Differenz aus Projektbudget aktuell abzgl. Projektprognose"
                      class="text-muted"
                    ></b-icon>
                  </h6>
                </div>
                <hr class="m-0 pb-0" style="position: relative; left: 50%; width: 50%; top: 18px" />
                <h2 class="my-0">
                  <b-badge
                    style="
                      min-width: 200px;
                      position: relative;
                      top: -4px;
                      border-left: 8px solid white;
                      border-right: 8px solid white;
                    "
                    :variant="
                      report.KkeBudgetSummary -
                        report.KkeBudgetAllocatedSummary +
                        report.PatBudgetSummary -
                        report.PatBudgetAllocatedSummary +
                        report.VEBudgetOpen +
                        report.VEBudgetAusgeschrieben +
                        report.VEBudgetAusgewertet +
                        report.VEBudgetEmpfohlen +
                        report.VEBudgetBeauftragt +
                        report.VEBudgetAbgenommen +
                        report.OrderAmountLeistungInvoicedFinal +
                        report.PatBudgetOpen +
                        report.VECnRSkipped +
                        report.ProjectCnR +
                        report.VECnROpen +
                        report.VECnRAusgeschrieben +
                        report.VECnRAusgewertet +
                        report.VECnREmpfohlen +
                        report.VECnRBeauftragt +
                        report.VECnRAbgenommen +
                        report.VECnRInvoiced -
                        (report.KkeBudgetSummary + report.PatBudgetSummary) <
                      0
                        ? 'success-outline'
                        : 'danger-outline'
                    "
                  >
                    {{
                      $utils.formatCurrency(
                        report.KkeBudgetSummary -
                          report.KkeBudgetAllocatedSummary +
                          report.PatBudgetSummary -
                          report.PatBudgetAllocatedSummary +
                          report.VEBudgetOpen +
                          report.VEBudgetAusgeschrieben +
                          report.VEBudgetAusgewertet +
                          report.VEBudgetEmpfohlen +
                          report.VEBudgetBeauftragt +
                          report.VEBudgetAbgenommen +
                          report.OrderAmountLeistungInvoicedFinal +
                          report.PatBudgetOpen +
                          report.VECnRSkipped +
                          report.ProjectCnR +
                          report.VECnROpen +
                          report.VECnRAusgeschrieben +
                          report.VECnRAusgewertet +
                          report.VECnREmpfohlen +
                          report.VECnRBeauftragt +
                          report.VECnRAbgenommen +
                          report.VECnRInvoiced -
                          (report.KkeBudgetSummary + report.PatBudgetSummary),
                        SettingsStore
                      )
                    }}
                  </b-badge>
                </h2>
              </div>
            </td>
            <td colspan="4" class="border-left border-bottom border-top">
              <strong>Projektprognose inkl. Risiken</strong>
            </td>
            <td class="text-right bg-secondary-light border-bottom border-top border-right">
              <strong>
                {{
                  $utils.formatCurrency(
                    report.KkeBudgetSummary -
                      report.KkeBudgetAllocatedSummary +
                      report.PatBudgetSummary -
                      report.PatBudgetAllocatedSummary +
                      report.VEBudgetOpen +
                      report.VEBudgetAusgeschrieben +
                      report.VEBudgetAusgewertet +
                      report.VEBudgetEmpfohlen +
                      report.VEBudgetBeauftragt +
                      report.VEBudgetAbgenommen +
                      report.OrderAmountLeistungInvoicedFinal +
                      report.PatBudgetOpen +
                      report.VECnRSkipped +
                      report.ProjectCnR +
                      report.VECnROpen +
                      report.VECnRAusgeschrieben +
                      report.VECnRAusgewertet +
                      report.VECnREmpfohlen +
                      report.VECnRBeauftragt +
                      report.VECnRAbgenommen +
                      report.VECnRInvoiced,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
          </tr>
          <tr>
            <td colspan="5">Kosten-Kontroll-Einheiten (KKE)</td>
            <td class="text-right bg-primary-light text-nowrap">
              {{ $utils.formatCurrency(report.KkeBudgetSummary, SettingsStore) }}
            </td>
            <td colspan="7"></td>
            <td colspan="4" style="padding-left: 20px">Risiko PÄT in Prüfung</td>
            <td class="text-right bg-secondary-light text-nowrap">
              {{ $utils.formatCurrency(report.PatBudgetOpen, SettingsStore) }}
            </td>
          </tr>
          <tr>
            <td colspan="5">zzgl. Projekt-Änderungstestate (PÄT)</td>
            <td class="text-right bg-primary-light text-nowrap">
              {{ $utils.formatCurrency(report.PatBudgetSummary, SettingsStore) }}
            </td>
            <td colspan="7" class="text-center">
              <h6 class="mb-0">
                PROGNOSEABWEICHUNG vor Projektrisiken
                <b-icon
                  style="vertical-align: -0.12em; margin-left: 3px"
                  icon="question-circle"
                  title=" = Differenz aus Projektbudget aktuell abzgl. Projektprognose"
                  class="text-muted"
                ></b-icon>
              </h6>
            </td>
            <td colspan="4" style="padding-left: 20px">
              Chancen & Risiken Projekt
              <b-icon
                style="padding-top: 1px; margin-left: 1px"
                icon="question-circle"
                title="Chancen = negativer Wert, Risiken = positiver Wert"
                class="text-muted"
              ></b-icon>
            </td>
            <td class="text-right bg-secondary-light text-nowrap">
              <!--{{ $utils.formatCurrency(report.PatBudgetSummary, SettingsStore) }} -->
              {{ $utils.formatCurrency(report.ProjectCnR, SettingsStore) }}
            </td>
          </tr>
          <tr>
            <td class="border-left border-top border-bottom" colspan="5"><strong>Projektbudget aktuell</strong></td>
            <td class="text-right bg-primary-light border-top border-bottom border-right text-nowrap">
              <strong>
                {{ $utils.formatCurrency(report.KkeBudgetSummary + report.PatBudgetSummary, SettingsStore) }}
              </strong>
            </td>
            <td colspan="7" class="text-center">
              <div style="position: relative">
                <hr class="m-0 pb-0" style="position: relative; top: 18px" />
                <h2 class="my-0">
                  <b-badge
                    style="
                      min-width: 200px;
                      position: relative;
                      top: -4px;
                      border-left: 8px solid white;
                      border-right: 8px solid white;
                    "
                    :variant="
                      report.KkeBudgetSummary +
                        report.PatBudgetSummary -
                        (report.KkeBudgetSummary -
                          report.KkeBudgetAllocatedSummary +
                          report.PatBudgetSummary -
                          report.PatBudgetAllocatedSummary +
                          report.VEBudgetOpen +
                          report.VEBudgetAusgeschrieben +
                          report.VEBudgetAusgewertet +
                          report.VEBudgetEmpfohlen +
                          report.VEBudgetBeauftragt +
                          report.VEBudgetAbgenommen +
                          report.VECnRSkipped +
                          report.VECnROpen +
                          report.VECnRAusgeschrieben +
                          report.VECnRAusgewertet +
                          report.VECnREmpfohlen +
                          report.VECnRBeauftragt +
                          report.VECnRAbgenommen +
                          report.VECnRInvoiced +
                          report.OrderAmountLeistungInvoicedFinal) >
                      0
                        ? 'success-outline'
                        : 'danger-outline'
                    "
                  >
                    {{
                      $utils.formatCurrency(
                        (report.KkeBudgetSummary +
                          report.PatBudgetSummary -
                          (report.KkeBudgetSummary -
                            report.KkeBudgetAllocatedSummary +
                            report.PatBudgetSummary -
                            report.PatBudgetAllocatedSummary +
                            report.VEBudgetOpen +
                            report.VEBudgetAusgeschrieben +
                            report.VEBudgetAusgewertet +
                            report.VEBudgetEmpfohlen +
                            report.VEBudgetBeauftragt +
                            report.VEBudgetAbgenommen +
                            report.VECnRSkipped +
                            report.VECnROpen +
                            report.VECnRAusgeschrieben +
                            report.VECnRAusgewertet +
                            report.VECnREmpfohlen +
                            report.VECnRBeauftragt +
                            report.VECnRAbgenommen +
                            report.VECnRInvoiced +
                            report.OrderAmountLeistungInvoicedFinal)) *
                          -1,
                        SettingsStore
                      )
                    }}
                  </b-badge>
                </h2>
              </div>
            </td>
            <td colspan="4" class="border-top border-bottom border-left"><strong>Projektprognose</strong></td>
            <td class="text-right bg-secondary-light border-right border-top border-bottom text-nowrap">
              <strong>
                {{
                  $utils.formatCurrency(
                    report.KkeBudgetSummary -
                      report.KkeBudgetAllocatedSummary +
                      report.PatBudgetSummary -
                      report.PatBudgetAllocatedSummary +
                      report.VEBudgetOpen +
                      report.VEBudgetAusgeschrieben +
                      report.VEBudgetAusgewertet +
                      report.VEBudgetEmpfohlen +
                      report.VEBudgetBeauftragt +
                      report.VEBudgetAbgenommen +
                      report.VECnRSkipped +
                      report.VECnROpen +
                      report.VECnRAusgeschrieben +
                      report.VECnRAusgewertet +
                      report.VECnREmpfohlen +
                      report.VECnRBeauftragt +
                      report.VECnRAbgenommen +
                      report.VECnRInvoiced +
                      report.OrderAmountLeistungInvoicedFinal,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
          </tr>
          <!--
          <tr>
            <td colspan="5" class="text-right"></td>
            <td class="bg-primary-light"></td>
            <td colspan="7"></td>
            <td colspan="4"></td>
            <td class="text-right bg-secondary-light"></td>
          </tr>-->
          <!--
            <tr>
              <td class="indent-1">&nbsp;</td>
              <td colspan="4"><u>davon</u></td>
              <td class="text-right bg-primary-light">&nbsp;</td>
              <td colspan=7></td>
              <td colspan=4></td>
              <td class="text-right bg-secondary-light "></td>               
            </tr>-->
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td colspan="4">
              Freie Mittel
              <small>&nbsp;(gebunden, noch nicht zugewiesen)</small>
            </td>
            <td class="text-right bg-primary-light text-nowrap">
              {{
                $utils.formatCurrency(
                  report.KkeBudgetSummary -
                    report.KkeBudgetAllocatedSummary +
                    (report.PatBudgetSummary - report.PatBudgetAllocatedSummary),
                  SettingsStore
                )
              }}
            </td>
            <td colspan="7"></td>
            <td colspan="4" style="padding-left: 20px">Freie Mittel (gebunden)</td>
            <td class="text-right bg-secondary-light text-nowrap">
              {{
                $utils.formatCurrency(
                  report.KkeBudgetSummary -
                    report.KkeBudgetAllocatedSummary +
                    (report.PatBudgetSummary - report.PatBudgetAllocatedSummary),
                  SettingsStore
                )
              }}
            </td>
          </tr>
          <!---
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td colspan="4" class="border-left border-top border-bottom"><strong>VE-budgetiert</strong></td>
            <td class="text-right bg-primary-light border-right border-top border-bottom">
              {{
                $utils.formatCurrency(
                  report.KkeBudgetSummary +
                    report.PatBudgetSummary -
                    (report.KkeBudgetSummary -
                      report.KkeBudgetAllocatedSummary +
                      (report.PatBudgetSummary - report.PatBudgetAllocatedSummary)),
                  SettingsStore
                )
              }}
            </td>
            <td colspan="7"></td>
            <td colspan="4"></td>
            <td class="bg-secondary-light"></td>
          </tr>-->
          <!--
          <tr>
            <td colspan="5" class="text-right"></td>
            <td class="bg-primary-light"></td>
<td colspan="7"></td>
            <td colspan="4"></td>
            <td class="bg-secondary-light"></td>
          </tr>-->
          <!--
            <tr>
              <td class="indent-1">&nbsp;</td>
              <td class="indent-1">&nbsp;</td>
              <td colspan="3"><u>davon</u></td>
              <td class="text-right bg-primary-light">&nbsp;</td>
              <td colspan=7></td>
              <td colspan=4></td>
              <td class="bg-secondary-light ">        </td>      
            </tr>-->

          <tr>
            <td class="indent-1">&nbsp;</td>
            <td colspan="4" class="border-left border-top border-bottom"><strong>VE-Budget aktuell</strong></td>
            <td class="text-right bg-primary-light border-right border-top border-bottom text-nowrap">
              <strong>
                {{
                  $utils.formatCurrency(
                    report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <td colspan="7"></td>
            <td colspan="4" class="border-left border-top border-bottom"><strong>VE-Prognose</strong></td>
            <td class="text-right bg-secondary-light border-right border-top border-bottom">
              <strong>
                {{
                  $utils.formatCurrency(
                    report.VEBudgetOpen +
                      report.VEBudgetAusgeschrieben +
                      report.VEBudgetAusgewertet +
                      report.VEBudgetEmpfohlen +
                      report.VEBudgetBeauftragt +
                      report.VEBudgetAbgenommen +
                      report.OrderAmountLeistungInvoicedFinal +
                      report.VECnRSkipped +
                      report.VECnROpen +
                      report.VECnRAusgeschrieben +
                      report.VECnRAusgewertet +
                      report.VECnREmpfohlen +
                      report.VECnRBeauftragt +
                      report.VECnRAbgenommen +
                      report.VECnRInvoiced,
                    /* + report.CnRSkipped + report.CnROpen + record.CnRAusgeschrieben + record.CnRAusgeschrieben + record.CnRAusgeschrieben + report.CnREmpfohlen + report.CnRBeauftragt + report.CnRAbgenommen + report.CnRAbgerechnet, */

                    SettingsStore
                  )
                }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="indent-1"></td>
            <td colspan="4"></td>
            <td class="text-right bg-primary-light"></td>
            <td colspan="7"></td>
            <td colspan="4"></td>
            <td class="text-right bg-secondary-light"></td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="3"><u>davon</u></td>
            <td class="bg-primary-light"></td>
            <td><small></small></td>
            <td class="border-left border-top border-bottom text-muted text-right">
              <small>LV-Preis/ Angebote</small>
            </td>
            <td class="border-top border-bottom text-muted text-right align-bottom"><small>+ / -</small></td>
            <td class="border-top border-bottom text-right align-bottom">
              <small><strong>Auftrags&shy;höhen</strong></small>
            </td>
            <td class="border-top border-bottom text-right">
              <small><strong>Nachtrags&shy;rückstellung</strong></small>
            </td>
            <td class="border-top border-bottom text-muted text-right"><small>Nachträge in Prüfung</small></td>
            <td class="border-top border-bottom text-muted text-right align-bottom"><small>Na.Rü.Rest</small></td>
            <td class="border-top border-bottom text-right align-bottom">
              <small><strong>abgerechnet</strong></small>
            </td>
            <td class="border-top border-bottom text-right align-bottom">
              <small><strong>Obligo</strong></small>
            </td>
            <td class="border-top border-right border-bottom text-right">
              <small><strong>Chancen & Risiken</strong></small>
            </td>
            <td></td>
            <td class="bg-secondary-light"></td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="3"><strong>VE entfallen</strong></td>
            <td class="text-right bg-primary-light">
              <strong>{{ $utils.formatCurrency(report.VEBudgetSkipped, SettingsStore) }}</strong>
            </td>
            <td>
              <small>
                <strong>
                  {{
                    $utils.numberWithMaxFrictionsDE(
                      (report.VEBudgetSkipped / (report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary)) *
                        100,
                      1
                    )
                  }}%
                </strong>
              </small>
            </td>
            <td colspan="8" class="border-left"></td>
            <!-- VE entfallen / Chancen & Risiken -->
            <td class="text-right border-right text-muted">
              <strong>{{ $utils.formatCurrency(report.VECnRSkipped, SettingsStore) }}</strong>
            </td>
            <td></td>
            <td class="bg-secondary-light text-right">
              <strong>
                {{
                  $utils.formatCurrency(
                    /*report.VEBudgetSkipped */ report.VECnRSkipped /* + CnRSkipped */,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="indent-1"></td>
            <td colspan="4"></td>
            <td class="text-right bg-primary-light"></td>
            <td></td>
            <td colspan="9" class="border-left border-right"></td>
            <td></td>
            <td class="text-right bg-secondary-light"></td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="3"><strong>VE offen</strong></td>
            <td class="text-right bg-primary-light">
              <strong>{{ $utils.formatCurrency(report.VEBudgetOpen, SettingsStore) }}</strong>
            </td>
            <td>
              <small>
                <strong>
                  {{
                    $utils.numberWithMaxFrictionsDE(
                      (report.VEBudgetOpen /
                        (report.KkeBudgetSummary +
                          (report.PatBudgetSummary -
                            (report.KkeBudgetSummary -
                              report.KkeBudgetAllocatedSummary +
                              (report.PatBudgetSummary - report.PatBudgetAllocatedSummary))))) *
                        100,
                      1
                    )
                  }}%
                </strong>
              </small>
            </td>
            <td colspan="8" class="border-left"></td>
            <!-- VE offen / Chancen & Risiken -->
            <td class="text-right border-right text-muted">
              <strong>{{ $utils.formatCurrency(report.VECnROpen, SettingsStore) }}</strong>
            </td>
            <td></td>
            <td class="bg-secondary-light text-right">
              <strong>{{ $utils.formatCurrency(report.VEBudgetOpen + report.VECnROpen, SettingsStore) }}</strong>
            </td>
          </tr>
          <tr>
            <td class="indent-1"></td>
            <td colspan="4"></td>
            <td class="text-right bg-primary-light"></td>
            <td></td>
            <td colspan="9" class="border-left border-right"></td>
            <td></td>
            <td class="text-right bg-secondary-light"></td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="3"><strong>VE in Ausschreibung/Vergabe</strong></td>
            <td class="text-right bg-primary-light text-nowrap">
              <!-- VE in Ausschreibung/Vergabe / Budget -->
              <strong>
                {{ $utils.formatCurrency(report.VEBudgetAusgeschrieben + report.VEBudgetAusgewertet, SettingsStore) }}
              </strong>
            </td>
            <td class="text-right">
              <small>
                <!-- VE in Ausschreibung/Vergabe / Budget Prozent -->
                <strong>
                  {{
                    $utils.numberWithMaxFrictionsDE(
                      ((report.VEBudgetAusgeschrieben + report.VEBudgetAusgewertet) /
                        (report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary)) *
                        100,
                      1
                    )
                  }}%
                </strong>
              </small>
            </td>
            <td class="border-left text-right text-muted text-nowrap">
              <!-- VE in Ausschreibung/Vergabe / LV-Preis/ Angebote -->

              <strong>
                {{ $utils.formatCurrency(report.VELVAusgeschrieben + report.VEActiveQuotes, SettingsStore) }}
              </strong>
            </td>
            <td></td>
            <td colspan="6"></td>
            <!-- VE in Ausschreibung/Vergabe / Chancen & Risiken -->
            <td class="border-right text-right text-muted text-nowrap">
              <!-- <strong>{{ $utils.formatCurrency(1114, SettingsStore) }}</strong> -->
              <strong>
                {{ $utils.formatCurrency(report.VECnRAusgeschrieben + report.VECnRAusgewertet, SettingsStore) }}
              </strong>
            </td>
            <td></td>
            <td class="text-right bg-secondary-light text-nowrap">
              <strong>
                {{
                  $utils.formatCurrency(
                    report.VEBudgetAusgeschrieben +
                      report.VEBudgetAusgewertet +
                      report.VECnRAusgeschrieben +
                      report.VECnRAusgewertet,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="2">VE-ausgeschrieben</td>
            <td class="text-right bg-primary-light">
              {{ $utils.formatCurrency(report.VEBudgetAusgeschrieben, SettingsStore) }}
            </td>
            <td class="text-right">
              <small>
                {{
                  $utils.numberWithMaxFrictionsDE(
                    (report.VEBudgetAusgeschrieben /
                      (report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary)) *
                      100,
                    1
                  )
                }}%
              </small>
            </td>
            <td class="border-left text-right text-muted">
              {{ $utils.formatCurrency(report.VELVAusgeschrieben, SettingsStore) }}
            </td>
            <td class="text-right text-muted text-nowrap">
              {{ $utils.formatCurrency(report.VEBudgetAusgeschrieben - report.VELVAusgeschrieben, SettingsStore) }}
            </td>
            <td colspan="6"></td>
            <!-- VE-ausgeschrieben / Chancen & Risiken -->
            <td class="border-right text-right text-muted">
              <!-- {{ $utils.formatCurrency(1117, SettingsStore) }} -->
              {{ $utils.formatCurrency(report.VECnRAusgeschrieben, SettingsStore) }}
            </td>
            <td></td>
            <td class="text-right bg-secondary-light">
              {{ $utils.formatCurrency(report.VEBudgetAusgeschrieben + report.VECnRAusgeschrieben, SettingsStore) }}
            </td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="2">VE-ausgewertet</td>
            <td class="text-right bg-primary-light">
              {{ $utils.formatCurrency(report.VEBudgetAusgewertet, SettingsStore) }}
            </td>
            <td class="text-right">
              <small>
                {{
                  $utils.numberWithMaxFrictionsDE(
                    (report.VEBudgetAusgewertet /
                      (report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary)) *
                      100,
                    1
                  )
                }}%
              </small>
            </td>
            <td class="border-left text-right text-muted">
              {{ $utils.formatCurrency(report.VEActiveQuotes, SettingsStore) }}
            </td>
            <td class="text-right text-muted text-nowrap">
              {{ $utils.formatCurrency(report.VEBudgetAusgewertet - report.VEActiveQuotes, SettingsStore) }}
            </td>
            <td colspan="6"></td>
            <!-- VE-ausgewertet / Chancen & Risiken -->
            <td class="border-right text-right text-muted">
              <!--{{ $utils.formatCurrency(1109, SettingsStore) }}-->
              {{ $utils.formatCurrency(report.VECnRAusgewertet, SettingsStore) }}
            </td>
            <td></td>
            <td class="text-right bg-secondary-light">
              {{
                $utils.formatCurrency(
                  report.VEBudgetAusgewertet +
                    report.VECnRAusgeschrieben +
                    report.VECnRAusgewertet +
                    report.VECnRAusgeschrieben,
                  SettingsStore
                )
              }}
            </td>
          </tr>
          <tr>
            <td colspan="5" class="text-right"></td>
            <td class="bg-primary-light"></td>
            <td></td>
            <td colspan="8" class="border-left"></td>
            <td class="border-right"></td>
            <td></td>
            <td class="bg-secondary-light"></td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="3"><strong>VE in Arbeit befindlich</strong></td>
            <td class="text-right bg-primary-light">
              <strong>{{ $utils.formatCurrency(report.VEBudgetInArbeit, SettingsStore) }}</strong>
            </td>
            <td class="text-right">
              <small>
                <strong>
                  {{
                    $utils.numberWithMaxFrictionsDE(
                      (report.VEBudgetInArbeit /
                        (report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary)) *
                        100,
                      1
                    )
                  }}%
                </strong>
              </small>
            </td>
            <td class="border-left"></td>
            <td></td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE in Arbeit befindlich / Auftragshöhen -->
              <strong>
                {{
                  $utils.formatCurrency(
                    report.OrderMainOrdersEmpfohlen +
                      report.OrderOrderedAddendumsEmpfohlen +
                      report.OrderMainOrdersBeauftragt +
                      report.OrderOrderedAddendumsBeauftragt +
                      report.OrderMainOrdersAbgenommen +
                      report.OrderOrderedAddendumsAbgenommen,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE in Arbeit befindlich / Nachtragsrückstellung -->
              <strong>
                {{
                  $utils.formatCurrency(
                    report.VEBudgetInArbeit -
                      (report.OrderMainOrdersEmpfohlen +
                        report.OrderOrderedAddendumsEmpfohlen +
                        report.OrderMainOrdersBeauftragt +
                        report.OrderOrderedAddendumsBeauftragt +
                        report.OrderMainOrdersAbgenommen +
                        report.OrderOrderedAddendumsAbgenommen),
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <!-- VE in Arbeit befindlich / Nachträge in Prüfung Summe -->
            <td class="text-right text-nowrap text-muted">
              {{
                $utils.formatCurrency(
                  report.AddendumsEmpfohlen + report.AddendumsBeauftragt + report.AddendumsAbgenommen,
                  SettingsStore
                )
              }}
            </td>
            <!-- VE in Arbeit befindlich / + / - Abweichung Summe -->
            <td class="text-right text-nowrap text-muted">
              {{
                $utils.formatCurrency(
                  report.VEBudgetInArbeit -
                    (report.OrderMainOrdersEmpfohlen +
                      report.OrderOrderedAddendumsEmpfohlen +
                      report.OrderMainOrdersBeauftragt +
                      report.OrderOrderedAddendumsBeauftragt +
                      report.OrderMainOrdersAbgenommen +
                      report.OrderOrderedAddendumsAbgenommen) -
                    (report.AddendumsEmpfohlen + report.AddendumsBeauftragt + report.AddendumsAbgenommen),
                  SettingsStore
                )
              }}
            </td>
            <!-- VE in arbeit befindlich / Abgerechnet Summe -->
            <td class="text-right text-nowrap text-muted">
              <strong>
                {{
                  $utils.formatCurrency(
                    report.OrderInvoicedEmpfohlen + report.OrderInvoicedBeauftragt + report.OrderInvoicedAbgenommen,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <!-- VE in arbeit befindlich / Obligo Summe -->
            <td class="text-right text-nowrap text-muted">
              <strong>
                {{
                  $utils.formatCurrency(
                    report.OrderMainOrdersEmpfohlen +
                      report.OrderOrderedAddendumsEmpfohlen -
                      report.OrderInvoicedEmpfohlen +
                      (report.OrderMainOrdersBeauftragt +
                        report.OrderOrderedAddendumsBeauftragt -
                        report.OrderInvoicedBeauftragt) +
                      (report.OrderMainOrdersAbgenommen +
                        report.OrderOrderedAddendumsAbgenommen -
                        report.OrderInvoicedAbgenommen),
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <!-- VE in Arbeit befindlich / Chancen & Risiken -->
            <td class="border-right text-right text-nowrap text-muted">
              <strong>
                <!--{{ $utils.formatCurrency(1126, SettingsStore) }}-->
                <strong>{{ $utils.formatCurrency(report.VECnRInArbeit, SettingsStore) }}</strong>
              </strong>
            </td>
            <td></td>
            <!-- VE in Arbeit befindlich / SUMME -->
            <td class="text-right bg-secondary-light text-nowrap">
              <strong>
                {{ $utils.formatCurrency(report.VEBudgetInArbeit + report.VECnRInArbeit, SettingsStore) }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="2">VE-empfohlen</td>
            <td class="text-right bg-primary-light">
              {{ $utils.formatCurrency(report.VEBudgetEmpfohlen, SettingsStore) }}
            </td>
            <td class="text-right">
              <small>
                {{
                  $utils.numberWithMaxFrictionsDE(
                    (report.VEBudgetEmpfohlen / (report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary)) *
                      100,
                    1
                  )
                }}%
              </small>
            </td>
            <td class="border-left"></td>
            <td></td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE-empfohlen / Auftragshöhen -->
              {{
                $utils.formatCurrency(
                  report.OrderMainOrdersEmpfohlen + report.OrderOrderedAddendumsEmpfohlen,
                  SettingsStore
                )
              }}
            </td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE-empfohlen / Nachtrags­rückstellung -->
              {{
                $utils.formatCurrency(
                  report.VEBudgetEmpfohlen - (report.OrderMainOrdersEmpfohlen + report.OrderOrderedAddendumsEmpfohlen),
                  SettingsStore
                )
              }}
            </td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE-empfohlen / Nachträge in Prüfung -->
              {{ $utils.formatCurrency(report.AddendumsEmpfohlen, SettingsStore) }}
            </td>

            <td class="text-right text-nowrap text-muted">
              <!-- VE-empfohlen / + / - -->
              {{
                $utils.formatCurrency(
                  report.VEBudgetEmpfohlen -
                    (report.OrderMainOrdersEmpfohlen + report.OrderOrderedAddendumsEmpfohlen) -
                    report.AddendumsEmpfohlen,
                  SettingsStore
                )
              }}
            </td>
            <!-- VE-empfohlen / Abgerechnet -->
            <td class="text-right text-nowrap text-muted">
              {{ $utils.formatCurrency(report.OrderInvoicedEmpfohlen, SettingsStore) }}
            </td>
            <!-- VE-empfohlen / Obligo -->
            <td class="text-right text-nowrap text-muted">
              {{
                $utils.formatCurrency(
                  report.OrderMainOrdersEmpfohlen +
                    report.OrderOrderedAddendumsEmpfohlen -
                    report.OrderInvoicedEmpfohlen,
                  SettingsStore
                )
              }}
            </td>
            <!-- VE-empfohlen / Chancen & Risiken -->
            <td class="border-right text-right text-nowrap text-muted">
              <!--{{ $utils.formatCurrency(1132, SettingsStore) }}-->
              {{ $utils.formatCurrency(report.VECnREmpfohlen, SettingsStore) }}
            </td>
            <td></td>
            <!-- VE-empfohlen / SUMME -->
            <td class="text-right text-nowrap bg-secondary-light">
              {{ $utils.formatCurrency(report.VEBudgetEmpfohlen + report.VECnREmpfohlen, SettingsStore) }}
            </td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="2">VE-beauftragt</td>
            <td class="text-right bg-primary-light">
              <!-- Ve-beauftragt / Budget -->
              {{ $utils.formatCurrency(report.VEBudgetBeauftragt, SettingsStore) }}
            </td>
            <td class="text-right">
              <small>
                <!-- Ve-beauftragt / Budget Prozent -->
                {{
                  $utils.numberWithMaxFrictionsDE(
                    (report.VEBudgetBeauftragt /
                      (report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary)) *
                      100,
                    1
                  )
                }}%
              </small>
            </td>
            <td class="border-left"></td>
            <td></td>
            <td class="text-right text-nowrap text-muted">
              <!-- Ve-beauftragt / Auftragshöhe -->
              {{
                $utils.formatCurrency(
                  report.OrderMainOrdersBeauftragt + report.OrderOrderedAddendumsBeauftragt,
                  SettingsStore
                )
              }}
            </td>
            <td class="text-right text-nowrap text-muted">
              <!-- Ve-beauftragt / Nachtrags­rückstellung -->
              {{
                $utils.formatCurrency(
                  report.VEBudgetBeauftragt -
                    (report.OrderMainOrdersBeauftragt + report.OrderOrderedAddendumsBeauftragt),
                  SettingsStore
                )
              }}
            </td>
            <td class="text-right text-nowrap text-muted">
              <!-- Ve-beauftragt / Nachträge in Prüfung -->
              {{ $utils.formatCurrency(report.AddendumsBeauftragt, SettingsStore) }}
            </td>

            <td class="text-right text-nowrap text-muted">
              <!-- Ve-beauftragt / + / - -->
              {{
                $utils.formatCurrency(
                  report.VEBudgetBeauftragt -
                    (report.OrderMainOrdersBeauftragt + report.OrderOrderedAddendumsBeauftragt) -
                    report.AddendumsBeauftragt,
                  SettingsStore
                )
              }}
            </td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE-beauftragt / abgerechnet -->
              {{ $utils.formatCurrency(report.OrderInvoicedBeauftragt, SettingsStore) }}
            </td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE-beauftragt / Obligo -->
              {{
                $utils.formatCurrency(
                  report.OrderMainOrdersBeauftragt +
                    report.OrderOrderedAddendumsBeauftragt -
                    report.OrderInvoicedBeauftragt,
                  SettingsStore
                )
              }}
            </td>
            <!-- VE-beauftragt / Chancen & Risiken -->
            <td class="border-right text-right text-nowrap text-muted">
              {{ $utils.formatCurrency(report.VECnRBeauftragt, SettingsStore) }}
            </td>
            <td></td>
            <!-- VE-beauftragt / SUMME -->
            <td class="text-right text-nowrap bg-secondary-light">
              {{ $utils.formatCurrency(report.VEBudgetBeauftragt + report.VECnRBeauftragt, SettingsStore) }}
            </td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="2">VE-abgenommen</td>
            <td class="text-right bg-primary-light">
              {{ $utils.formatCurrency(report.VEBudgetAbgenommen, SettingsStore) }}
            </td>
            <td class="text-right">
              <small>
                {{
                  $utils.numberWithMaxFrictionsDE(
                    (report.VEBudgetAbgenommen /
                      (report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary)) *
                      100,
                    1
                  )
                }}%
              </small>
            </td>
            <td class="border-left"></td>
            <td></td>
            <td class="text-right text-nowrap text-muted">
              <!-- auftragshöhe -->
              {{
                $utils.formatCurrency(
                  report.OrderMainOrdersAbgenommen + report.OrderOrderedAddendumsAbgenommen,
                  SettingsStore
                )
              }}
            </td>
            <td class="text-right text-nowrap text-muted">
              {{
                $utils.formatCurrency(
                  report.VEBudgetAbgenommen -
                    (report.OrderMainOrdersAbgenommen + report.OrderOrderedAddendumsAbgenommen),
                  SettingsStore
                )
              }}
            </td>
            <td class="text-right text-nowrap text-muted">
              {{ $utils.formatCurrency(report.AddendumsAbgenommen, SettingsStore) }}
            </td>

            <td class="text-right text-nowrap text-muted">
              <!-- VE-abgenommen / + / - Abweichung -->
              {{
                $utils.formatCurrency(
                  report.VEBudgetAbgenommen -
                    (report.OrderMainOrdersAbgenommen + report.OrderOrderedAddendumsAbgenommen) -
                    report.AddendumsAbgenommen,
                  SettingsStore
                )
              }}
            </td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE-abgenommen / abgerechnet -->
              {{ $utils.formatCurrency(report.OrderInvoicedAbgenommen, SettingsStore) }}
            </td>
            <!-- VE-abgenommen / Obligo -->
            <td class="text-right text-nowrap text-muted">
              {{
                $utils.formatCurrency(
                  report.OrderMainOrdersAbgenommen +
                    report.OrderOrderedAddendumsAbgenommen -
                    report.OrderInvoicedAbgenommen,
                  SettingsStore
                )
              }}
            </td>
            <!-- VE-abgenommen / Chancen & Risiken -->
            <td class="border-right text-right text-nowrap text-muted">
              <!--{{ $utils.formatCurrency(1139, SettingsStore) }}-->
              {{ $utils.formatCurrency(report.VECnRAbgenommen, SettingsStore) }}
            </td>
            <td></td>
            <td class="text-right bg-secondary-light">
              {{ $utils.formatCurrency(report.VEBudgetAbgenommen + report.VECnRAbgenommen, SettingsStore) }}
            </td>
          </tr>
          <tr>
            <td colspan="5" class="text-right"></td>
            <td class="bg-primary-light"></td>
            <td></td>
            <td colspan="8" class="border-left"></td>
            <td class="border-right"></td>
            <td></td>
            <td class="bg-secondary-light"></td>
          </tr>
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="3"><strong>VE schlussgerechnet</strong></td>
            <td class="text-right bg-primary-light">
              <strong>{{ $utils.formatCurrency(report.VEBudgetInvoiced, SettingsStore) }}</strong>
            </td>
            <td>
              <small>
                <strong>
                  {{
                    $utils.numberWithMaxFrictionsDE(
                      (report.VEBudgetInvoiced /
                        (report.KkeBudgetAllocatedSummary + report.PatBudgetAllocatedSummary)) *
                        100,
                      1
                    )
                  }}%
                </strong>
              </small>
            </td>

            <td class="border-left"></td>
            <td></td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE Schlussgerechnet / Auftragshöhe -->
              <strong>
                {{
                  $utils.formatCurrency(
                    report.OrderMainOrdersAbgerechnet + report.OrderOrderedAddendumsAbgerechnet,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <td class="text-right text-nowrap text-muted">
              <!-- VE Schlussgerechnet / Nachtragsrückstellung -->
              <strong>
                {{
                  $utils.formatCurrency(
                    report.VEBudgetInvoiced -
                      (report.OrderMainOrdersAbgerechnet + report.OrderOrderedAddendumsAbgerechnet),
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <!-- VE Schlussgerechnet / Nachträge in Prüfung -->
            <td class="text-right text-nowrap text-muted">
              {{ $utils.formatCurrency(report.AddendumsAbgerechnet, SettingsStore) }}
            </td>
            <!-- VE Schlussgerechnet / + / - Abweichung -->
            <td class="text-right text-nowrap text-muted">
              {{
                $utils.formatCurrency(
                  report.VEBudgetInvoiced -
                    (report.OrderMainOrdersAbgerechnet + report.OrderOrderedAddendumsAbgerechnet) -
                    report.AddendumsAbgerechnet,
                  SettingsStore
                )
              }}
            </td>
            <!-- VE Schlussgerechnet / Abgerechnet -->
            <td class="text-right text-nowrap text-muted">
              <strong>{{ $utils.formatCurrency(report.OrderAmountLeistungInvoicedFinal, SettingsStore) }}</strong>
            </td>
            <!-- VE Schlussgerechnet / Obligo -->
            <td class="text-right text-nowrap text-muted">
              <strong>
                0 €
                <!--{{ $utils.formatCurrency(report.OrderMainOrdersAbgerechnet + report.OrderOrderedAddendumsAbgerechnet - report.OrderAmountLeistungInvoicedFinal, SettingsStore) }}-->
              </strong>
            </td>
            <!-- VE Schlussgerechnet / Chancen & Risiken -->
            <td class="border-right text-right text-nowrap text-muted">
              <strong>
                {{ $utils.formatCurrency(report.VECnRInvoiced, SettingsStore) }}
              </strong>
            </td>
            <td></td>
            <!-- VE Schlussgerechnet / Summe -->
            <td class="text-right bg-secondary-light">
              <strong>
                {{
                  $utils.formatCurrency(report.OrderAmountLeistungInvoicedFinal + report.VECnRInvoiced, SettingsStore)
                }}
              </strong>
            </td>
          </tr>
          <tr>
            <td colspan="5" class="text-right"></td>
            <td class="bg-primary-light"></td>
            <td></td>
            <td colspan="9" class="border-left border-right border-bottom"></td>
            <td></td>
            <td class="bg-secondary-light"></td>
          </tr>
          <!--- Summenzeile -->
          <tr>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td class="indent-1">&nbsp;</td>
            <td colspan="2"><strong></strong></td>
            <td class="text-right bg-primary-light"></td>
            <td><small></small></td>
            <td class="border-left border-bottom"></td>
            <td class="border-bottom"></td>
            <td class="text-right text-nowrap border-bottom">
              <!--- Summenzeile / Auftragshöhen -->
              <strong>
                {{
                  $utils.formatCurrency(
                    report.OrderMainOrdersEmpfohlen +
                      report.OrderOrderedAddendumsEmpfohlen +
                      report.OrderMainOrdersBeauftragt +
                      report.OrderOrderedAddendumsBeauftragt +
                      report.OrderMainOrdersAbgenommen +
                      report.OrderOrderedAddendumsAbgenommen +
                      (report.OrderMainOrdersAbgerechnet + report.OrderOrderedAddendumsAbgerechnet),
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <!-- Summenzeile / Summe Nachtragsrückstellung -->
            <td class="text-right text-nowrap border-bottom">
              <strong>
                {{
                  $utils.formatCurrency(
                    report.VEBudgetInvoiced -
                      (report.OrderMainOrdersAbgerechnet + report.OrderOrderedAddendumsAbgerechnet) +
                      (report.VEBudgetInArbeit -
                        (report.OrderMainOrdersEmpfohlen +
                          report.OrderOrderedAddendumsEmpfohlen +
                          report.OrderMainOrdersBeauftragt +
                          report.OrderOrderedAddendumsBeauftragt +
                          report.OrderMainOrdersAbgenommen +
                          report.OrderOrderedAddendumsAbgenommen)),
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <!-- Summenzeile / Summe Nachträge in Prüfung -->
            <td class="text-right text-nowrap border-bottom">
              {{
                $utils.formatCurrency(
                  report.AddendumsEmpfohlen +
                    report.AddendumsBeauftragt +
                    report.AddendumsAbgenommen +
                    report.AddendumsAbgerechnet,
                  SettingsStore
                )
              }}
            </td>

            <td class="text-right text-nowrap border-bottom">
              <!--- Summenzeile / + / - -->

              {{
                /*
                $utils.formatCurrency(
                  report.VEBudgetInArbeit -
                    (report.OrderMainOrdersEmpfohlen +
                      report.OrderOrderedAddendumsEmpfohlen +
                      report.OrderMainOrdersBeauftragt +
                      report.OrderOrderedAddendumsBeauftragt +
                      report.OrderMainOrdersAbgenommen +
                      report.OrderOrderedAddendumsAbgenommen) -
                    (report.AddendumsEmpfohlen + report.AddendumsBeauftragt + report.AddendumsAbgenommen) +
                    (report.VEBudgetEmpfohlen -
                      (report.OrderMainOrdersEmpfohlen + report.OrderOrderedAddendumsEmpfohlen) -
                      report.AddendumsEmpfohlen) +
                    (report.VEBudgetBeauftragt -
                      (report.OrderMainOrdersBeauftragt + report.OrderOrderedAddendumsBeauftragt) -
                      report.AddendumsBeauftragt) +
                    (report.VEBudgetAbgenommen -
                      (report.OrderMainOrdersAbgenommen + report.OrderOrderedAddendumsAbgenommen) -
                      report.AddendumsAbgenommen) +
                    (report.VEBudgetInvoiced -
                      (report.OrderMainOrdersAbgerechnet + report.OrderOrderedAddendumsAbgerechnet) -
                      report.AddendumsAbgerechnet),
                  SettingsStore
                )*/
                $utils.formatCurrency(
                  report.VEBudgetInvoiced -
                    (report.OrderMainOrdersAbgerechnet + report.OrderOrderedAddendumsAbgerechnet) +
                    (report.VEBudgetInArbeit -
                      (report.OrderMainOrdersEmpfohlen +
                        report.OrderOrderedAddendumsEmpfohlen +
                        report.OrderMainOrdersBeauftragt +
                        report.OrderOrderedAddendumsBeauftragt +
                        report.OrderMainOrdersAbgenommen +
                        report.OrderOrderedAddendumsAbgenommen)) -
                    (report.AddendumsEmpfohlen +
                      report.AddendumsBeauftragt +
                      report.AddendumsAbgenommen +
                      report.AddendumsAbgerechnet),
                  SettingsStore
                )
              }}
            </td>
            <td class="text-right text-nowrap border-bottom">
              <!-- Summenzeile / abgerechnet -->
              <strong>
                {{
                  $utils.formatCurrency(
                    report.OrderInvoicedEmpfohlen +
                      report.OrderInvoicedBeauftragt +
                      report.OrderInvoicedAbgenommen +
                      report.OrderAmountLeistungInvoicedFinal,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <td class="text-right text-nowrap border-bottom">
              <!-- Summenzeile / Obligo -->
              <!--
              {{
                $utils.formatCurrency(
                  report.OrderMainOrdersEmpfohlen +
                    report.OrderOrderedAddendumsEmpfohlen -
                    report.OrderInvoicedEmpfohlen +
                    (report.OrderMainOrdersBeauftragt +
                      report.OrderOrderedAddendumsBeauftragt -
                      report.OrderInvoicedBeauftragt) +
                    (report.OrderMainOrdersAbgenommen +
                      report.OrderOrderedAddendumsAbgenommen -
                      report.OrderInvoicedAbgenommen) +
                    report.OrderMainOrdersAbgerechnet +
                    report.OrderOrderedAddendumsAbgerechnet -
                    report.OrderAmountLeistungInvoicedFinal,
                  SettingsStore
                )
              }}-->
              <strong>
                {{
                  $utils.formatCurrency(
                    report.OrderMainOrdersEmpfohlen +
                      report.OrderOrderedAddendumsEmpfohlen -
                      report.OrderInvoicedEmpfohlen +
                      (report.OrderMainOrdersBeauftragt +
                        report.OrderOrderedAddendumsBeauftragt -
                        report.OrderInvoicedBeauftragt) +
                      (report.OrderMainOrdersAbgenommen +
                        report.OrderOrderedAddendumsAbgenommen -
                        report.OrderInvoicedAbgenommen),
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <!-- Summenzeile / Chancen & Risiken -->
            <td class="border-right text-right text-nowrap border-bottom">
              <strong>
                {{
                  $utils.formatCurrency(
                    report.VECnRSkipped +
                      report.VECnROpen +
                      report.VECnRAusgeschrieben +
                      report.VECnRAusgewertet +
                      report.VECnREmpfohlen +
                      report.VECnRBeauftragt +
                      report.VECnRAbgenommen +
                      report.VECnRInvoiced,
                    SettingsStore
                  )
                }}
              </strong>
            </td>
            <td></td>
            <td class="bg-secondary-light"></td>
          </tr>
        </table>
      </b-tab>
      <b-tab
        title="Diagramm"
        class="p-4"
        :style="{ height: 'calc(100vh - 100px)', overflowY: 'auto', overflowX: 'auto', position: 'relative' }"
        v-if="report.KkeBudgetSummary"
      ></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import SettingsStore from '@/store/Settings';
import ReportingService from '@/service/ReportingService';

export default {
  data() {
    return {
      report: {
        KkeBudgetSummary: 1
      },
      activeTab: 0,
      SettingsStore,
      AppState
    };
  },
  components: {},
  methods: {},
  activated() {
    this.report.KkeBudgetSummary = null;
    ReportingService.getReport()
      .then(report => (this.report = report))
      .catch(err => {
        if (err.response) this.$showError(this, err.response.data.error);
        else this.$showError(this, err.toString());
      })
      .finally(() => {
        AppState.isLoading = false;
        this.$refs.tabA.activate();
      });
  }
};
</script>

<style>
.inverted {
  background-color: white !important;
}
.inverted.nav-tabs {
  border-bottom: 1px solid rgb(222, 226, 230) !important;
}
.inverted .nav-link.active {
  background-color: var(--bauvisor-light) !important;
  border-bottom: 1px solid var(--bauvisor-light) !important;
}
.bg-transparent {
  background-color: var(--bauvisor-light) !important;
}
.inverted.nav-tabs:first-child {
  color: red;
  padding-left: 33px;
}

#reportTable td {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.indent-1 {
  width: 20px !important;
}
</style>
